var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerHeadingTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#3B4A6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84251 19.8634C7.06231 25.5849 12.8708 28.431 17.2998 25.4687L17.9387 25.033L18.5052 25.6865C20.2042 27.6178 23.6602 27.2984 24.3427 25.1492C24.4443 24.8152 24.6041 24.8007 24.8509 25.0911C25.7658 26.1802 27.8859 26.0205 28.8298 24.7862C31.008 21.94 28.4813 16.7994 25.4463 17.9031C25.3156 17.9466 25.1849 17.7724 25.0687 17.3803C24.3862 15.1295 21.4531 13.2998 19.8848 14.142C19.6379 14.2727 19.5797 14.2437 19.5071 13.9968C17.1691 5.0226 3.89664 10.715 5.84251 19.8634ZM13.7276 11.9783C15.9058 11.9929 17.8661 13.1691 18.5341 15.5651C18.8536 16.6978 19.1876 17.0027 19.7104 16.6687C21.2932 15.6232 24.0379 17.4674 24.2412 19.7182C24.3428 20.7783 24.6768 21.2865 25.0398 20.9235C25.8095 20.1538 26.4918 20.0812 27.4503 20.6766C28.8298 21.5189 28.6846 23.0291 27.1889 23.5083C26.3902 23.7551 25.1414 23.1453 24.8074 22.3321C24.5024 21.6205 24.1394 21.7076 23.8489 22.5644C23.0212 25.033 19.7394 25.338 18.7665 23.0436C18.4325 22.2594 18.3163 22.2595 16.9949 22.9855C14.2939 24.4522 11.1863 23.9149 9.08075 22.3901C3.57714 18.4113 8.61606 11.9493 13.7276 11.9783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerHeadingTwo);
export default __webpack_public_path__ + "static/media/partnerHeadingTwo.684f1f1401a1010d59b95c5811eed2fe.svg";
export { ForwardRef as ReactComponent };